import type { FaireProductEntity } from "../../entity_types/product";

export const p_2rmcnjnw6h: FaireProductEntity = {
  token: "p_2rmcnjnw6h",
  type: "product",
  name: "DRAWSTRING MAXI SKIRT WITH ASYMMETRICAL SEAMS",
  brandToken: "b_22tswwgnqb",
  brandName: "Emory Park",
  imageUrl:
    "https://cdn.faire.com/fastly/25159f94915141e57642b836bd0229ddde4223d27c9c89cac192115596ff42cc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/839ec9b804c6ca3c1fb3f44b513b2e5724e0f9c670266c9bfb70b8246f7a4b3d.jpeg",
    "https://cdn.faire.com/fastly/a93760e26305e213706b7de123f1322b8692c599120f2f33f111a13d4f1dbfc5.jpeg",
    "https://cdn.faire.com/fastly/bf6f1109a6bb8c003de90a7de13d05e7e5bf37bafa489e259b4b09116ea0bd62.jpeg",
    "https://cdn.faire.com/fastly/b8ff38e8567118baac73400460f1d27863d085a5560d7df2c96562788feadd56.jpeg",
    "https://cdn.faire.com/fastly/e6b4e572a1a65f392f6489138a0dc14613016f32448e92178ad9dc13db76d498.jpeg",
    "https://cdn.faire.com/fastly/732a0bb3b91af6a04069d919fadf9d5e72f23258af0593ddb3994fdddc983e7c.jpeg",
  ],
  priceDollars: 33.26,
  description: "SIZE & FIT :\n\nMODEL WEARS SIZE SMALL\nMODEL'S HEIGHT 5'9",
  tags: [],
  msrpDollars: 66.51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:05.447Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
